<div class="barcode-reader">
  <sc-padding>
    <form class="form" [formGroup]="formGroup">
      <mat-form-field appearance="outline" appearance="fill">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.yard-simulator.barcode-reader"></sc-dictionary-label>
        </mat-label>
        <mat-select (valueChange)="onBarcodeReaderSelection($event)">
          @for (barcodeReader of barcodeReaders; track barcodeReader) {
            <mat-option [value]="barcodeReader">
              {{ barcodeReader.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <sc-flex vertical stretchContent>
        <sc-string-field formControlName="scannedNumber" labelDictionaryKey="tmc-yard.ui.admin.yard-simulator.barcode-protocol">
        </sc-string-field>
      </sc-flex>
    </form>

    <sc-button dictionaryKey="tmc-yard.ui.admin.yard-simulator.send" primary class="config-changed-button" (click)="onButtonTrigger()"
    [disabled]="!scannedNumber || !barcodeReaderSelected"></sc-button>
  </sc-padding>
</div>
